import { combineReducers } from 'redux';
import { cartReducer } from 'Components/widgets/cart/cart.reducer';
import { quickLogin } from './quick-login/quickLogin.reducer';
export const memberSpace = combineReducers({
  quickLogin,
  cart: cartReducer,
});
